import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';

import ReviewsList from '../pages/ReviewsList';
import RoleBasedGuard from '@/guards/RoleBasedGuard';

const REVIEWS_ROUTES = [
  {
    path: '',
    roles: ['reviews.view'],
    component: <ReviewsList />,
    index: true,
  },
];

export const ReviewsRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {REVIEWS_ROUTES.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>
              {route.component}
            </RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
